<template>
  <div>
    <div class="couponGet" v-show="appliData.length > 0">
      <div v-for="(value, index) in appliData" :key="index">
        <div class="coupon-content" v-if="index === current">
          <div class="coupon-img">
            <img :src="getImg(value.imgPath)"/>
          </div>
          <div class="buttonArea">
            <sub-btn v-if="current >= 1" @click="onPrev">前へ</sub-btn>
            <normal-btn v-if="current <= 3" @click="onNext">次へ</normal-btn>
            <normal-btn v-else @click="onHome">戻る</normal-btn>
          </div>
          <normal-btn class="getAppli" @click="onAppStore">アプリをダウンロードする</normal-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import NormalBtn from '../components/NormalBtn';
import SubBtn from '../components/SubBtn';
const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "AboutApplication",
  components: { NormalBtn, SubBtn},
  mixins: [Protobuf],
  data () {
    return {
      current: 0,
      appliData: []
    }
  },
  watch: {
    '$route.params.type'() {
      this.current = 0
    }
  },
  mounted(){
    const cmdNo = pb.KumaMasterSettingReq.CommandNo.COMMAND_NO
    const message = pb.KumaMasterSettingReq.create({
      id: this.id
    })
    const encoded = pb.KumaMasterSettingReq.encode(message).finish()

    this.post(cmdNo, encoded)
      .then(decoded => {
        if (decoded.status === pb.KumaMasterSettingResp.Status.SUCCESS) {
          this.appliData = decoded.masterTutorialList.slice(5, 10)
        } else {
          this.$_error('Error', { title: 'チュートリアル', statusCode: 100 })
        }
      })
      .catch(() => {
        this.$_error('Error', { title: 'チュートリアル', statusCode: 100 })
      })
  },
  methods: {
    onHome() {
      if(sessionStorage.getItem('prevPage')) {
        this.$router.push(sessionStorage.getItem('prevPage'))
      } else {
        this.$router.push('/Help')
      }
    },
    onNext() {
      this.current++
      window.scrollTo(0,0)
    },
    onPrev() {
      this.current = this.current -1
      window.scrollTo(0,0)
    },
    onAppStore() {
      window.open('https://app.adjust.com/g01bn92', '_blank')
    },
    getImg(img) {
      return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
    },
  }
}
</script>

<style lang="scss" scoped>
  .coupon-img {
    padding-top: 30px;
    img { max-width: 100%; }
  }
  .buttonArea {
    display: flex;
    .SubBtn { margin: 20px 0 0 30px; }
  }
  .getAppli {
    position: relative;
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 10px;
      left: 20px;
      width: 38px;
      height: 38px;
      background-image: url(../assets/Png/Application/image_icon_app.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: -10px;
      right: 20px;
      width: 54px;
      height: 28px;
      background-image: url(../assets/Png/Application/ic_free.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
</style>
